export default __webpack_public_path__ + "static/media/foto33_S_0417.1d6f3f62.png";